import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { PrintServices } from '../../../services/printServices';
import { HttpClient } from '@angular/common/http';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

@Component({
    selector: 'page-ingredient-view-label',
    templateUrl: 'ingredient-view-label.html',
})
export class IngredientViewLabelPage {

    ingredient: any;
    show_logo: boolean = false;
    elaboration_date: any;
    consumption_date: any;
    lote: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public printServices: PrintServices,
        public http: HttpClient,
        public cp: CurrencyPipe,
        private datePipe: DatePipe,
        public translate: TranslateService) {
        this.ingredient = this.navParams.get('ingredient');
    }

    ionViewWillEnter() {
        this.elaboration_date = this.globals.dateTimeNow(); //Get actual date
        this.elaboration_date = this.datePipe.transform(this.elaboration_date, 'yyyy-MM-dd'); //Format date

        this.consumption_date = this.globals.dateTimeNow(); //Get actual date
        this.consumption_date = this.datePipe.transform(this.consumption_date, 'yyyy-MM-dd'); //Format date
    }

    printLabel() {
        if (this.globals.checkLimitsByLicense('stock', 'print')) {//version pro abierto
            this.globals.GAtrackView('Ingredient', 'Ingredient - Label - Print', this.globals.restaurant.email, 'View', 'Print label', 'Ingredient', this.ingredient.name);
            var interval = setInterval(() => {
                this.printServices.printNow('print_label_ingredient');
                clearInterval(interval);
            }, 1000);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    getAllergens(allergens) {
        if (allergens) {
            var _allergens_text = ' ';
            for (let allergen of allergens) {
                _allergens_text += this.globals.getAllergenName(allergen).replace('*', '') + ', ';
            }
            _allergens_text = _allergens_text.substring(0, _allergens_text.length - 2);
            return _allergens_text;
        } else {
            return '';
        }
    }

    getIngredients(ingredients) {
        if (ingredients) {
            var _ingredients_text = ' ';
            for (let ingredient of ingredients) {
                _ingredients_text += ingredient.name_static + ', ';
            }
            _ingredients_text = _ingredients_text.substring(0, _ingredients_text.length - 2);
            return _ingredients_text;
        } else {
            return '';
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-label/ingredient-view-label.ts